import { createFileRoute } from "@tanstack/react-router";
import EsServicePage from "@/pages/es/EsServicePage";
import { esMedMgmt } from "@/pages/es/esServiceData";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/services/medication-management`;

export const Route = createFileRoute("/es/services/medication-management")({
  head: () => ({
    meta: [
      { title: "Manejo de medicación | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "Manejo psiquiátrico de medicación en Coral Springs, FL. Expertos certificados por junta que integran farmacoterapia con TMS, SPRAVATO® y ketamina.",
      },
      {
        property: "og:title",
        content: "Manejo de medicación | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content:
          "Manejo psiquiátrico de medicación certificado por junta en Coral Springs, FL.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "Manejo de medicación | Neuro Wellness TMS",
      },
      {
        name: "twitter:description",
        content:
          "Manejo psiquiátrico de medicación certificado por junta en Coral Springs, FL.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/services/medication-management"),
    ],
  }),
  component: () => <EsServicePage cfg={esMedMgmt} />,
});
